import cn from "classnames"
import React from "react"

import styles from "./index.module.css"

type ContentEditableProps = {
  className?: string
}

export const ContentEditable: React.FC<ContentEditableProps> = ({ children, className }) => {
  return <div className={cn(styles.Wrapper, className)}>{children}</div>
}
